import { z } from 'zod';

export const assetTypeSchema = z.enum([
  'Email',
  'Phone',
  'VehicleId',
  'DeviceId',
  'DriverId',
  'InventoryId',
]);

export type AssetType = z.infer<typeof assetTypeSchema>;
